const onWord = (word: string, doStuff: () => void) => {
  const expectedList = word.split('');
  let actualList: string[] = [];
  let currentIndex: number = 0;

  const reset = () => {
    actualList = [];
    currentIndex = 0;
  };

  const isWord = () => actualList.join('') === expectedList.join('');

  const onKeyUp = (event: KeyboardEvent) => {
    const key = event.key.toLowerCase();

    if (key === expectedList[currentIndex]) {
      actualList.push(key);
      currentIndex++;
    } else {
      reset();
    }
    if (isWord()) {
      doStuff();
      reset();
    }
  };

  document.addEventListener('keyup', onKeyUp);
  const cleanUp = () => {
    document.removeEventListener('keyup', onKeyUp);
  };

  return {
    cleanUp,
    isWord,
    reset,
  };
};

export default onWord;

// export const onWord = (thingToDo: (...args: any[]) => void) => onWord('awesome', thingToDo);
